import { ReactElement } from 'react';

const skeletonLoader = () => {
  return (null as unknown) as ReactElement;
};

export default skeletonLoader;
